import { UploadFile } from "antd";
import { SortableFilePreview } from "../sortable/SortableFilePreview";
import { UploadProgress } from "./UploadProgress";

export const UploadedItem = ({
  sortable,
  cardWidth,
  file,
  onAbort,
  remove,
  previewComponent,
}: {
  sortable: boolean;
  cardWidth: number;
  file: UploadFile;
  onAbort: () => void;
  remove: () => void;
  previewComponent: React.ReactNode;
}) => {
  return (
    <>
      {sortable ? (
        <SortableFilePreview
          width={cardWidth}
          fileName={file.name}
          key={file.name}
          format={file.type}
        />
      ) : (
        previewComponent
      )}
      <UploadProgress
        file={file}
        onAbort={onAbort}
        remove={remove}
        showRemoveIcon={true}
      />
    </>
  );
};
